import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { ObjectCardExpandedState } from '@common/components/object-card';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  public isLoading = new BehaviorSubject(false);

  /** Состояние аккордеонов карточки объекта — общее для всех карточек */
  stateObjectCardSettings: ObjectCardExpandedState = {
    general: true,
    drivers: true,
    trailers: true,
    geozones: true,
    sensors: true,
    params: true,
    connectionSettings: true,
    customFields: true,
    specifications: true,
    maintenance: true,
  };
}
